import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

export default function Breadcrumbs({ items = [], dark = false }) {
  const base = dark ? "text-white/85" : "text-slate-500";
  const linkHover = dark ? "hover:text-white" : "hover:text-slate-900";
  const current = dark ? "text-white font-semibold" : "text-slate-800 font-medium";
  const sep = dark ? "text-white/40" : "text-slate-400";
  return (
    <nav className={`text-sm flex items-center gap-1.5 flex-wrap ${base}`} data-testid="breadcrumbs">
      <Link to="/" className={`${linkHover} flex items-center gap-1`}>
        <Home size={14} /> Home
      </Link>
      {items.map((it, i) => (
        <span key={i} className="flex items-center gap-1.5">
          <ChevronRight size={14} className={sep} />
          {it.to ? (
            <Link to={it.to} className={linkHover}>{it.label}</Link>
          ) : (
            <span className={current}>{it.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}
